import { useInView, motion } from "framer-motion";
import { useRef } from "react";

export default function FadeInSection ({ children, ...props }) {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
  
    return (
      <motion.section
        ref={ref}
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: "easeOut" }}
        {...props}
      >
        {children}
      </motion.section>
    );
  };